var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEbook = function SvgEbook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 370.85 517.03",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}.cls-2{fill:#fcfcfc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 370.85,
    height: 517.03,
    rx: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.54,
    y: 40.16,
    width: 300.66,
    height: 406.31,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 148.7,
    y: 54.99,
    width: 80.32,
    height: 13.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 173.76,
    y: 418.43,
    width: 24.24,
    height: 13.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.87,
    y: 105.2,
    width: 229.03,
    height: 15.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.87,
    y: 133.93,
    width: 229.03,
    height: 15.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.87,
    y: 163.19,
    width: 229.03,
    height: 15.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.96,
    y: 192.44,
    width: 187.37,
    height: 15.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 94.43,
    y: 221.7,
    width: 205.51,
    height: 15.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.91,
    y: 250.44,
    width: 229.03,
    height: 15.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.91,
    y: 279.69,
    width: 229.03,
    height: 15.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71,
    y: 308.95,
    width: 228.94,
    height: 15.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.87,
    y: 337.47,
    width: 229.03,
    height: 15.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 70.87,
    y: 366.73,
    width: 229.03,
    height: 15.88
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEbook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ebook.2d10607f.svg";
export { ForwardRef as ReactComponent };